import { useState } from "react";
import SectionHead from "./SectionHead";
import { FAQ, TRUST } from "../../../mocks/chigua";

export default function Faq() {
  const [openId, setOpenId] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-16">
        <SectionHead
          no="06"
          kicker="Trust & FAQ · 围观须知"
          title="抓奸实录 · 围观须知与信任底线"
          sub="吃瓜可以上头，围观要有边界。聊得再热闹，也请记住：人物都打码、剧情都虚构、吐槽不伤真人。下面几条高频问题，帮你三秒进入状态。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          {/* 左：信任底线 */}
          <div className="lg:col-span-5 flex flex-col gap-4">
            <div className="rounded-lg border border-background-200/80 bg-background-50 p-5">
              <div className="inline-flex items-center gap-2 text-sm font-semibold text-foreground-900 mb-4">
                <span className="grid h-7 w-7 place-items-center rounded-full bg-accent-500 text-foreground-950">
                  <i className="ri-shield-check-line" />
                </span>
                我们守的四条底线
              </div>
              <div className="space-y-3">
                {TRUST.map((t) => (
                  <div key={t.title} className="flex gap-3 items-start rounded-md bg-background-100 p-3">
                    <span className="grid h-8 w-8 shrink-0 place-items-center rounded-md bg-primary-600 text-background-50 mt-0.5">
                      <i className={t.icon} />
                    </span>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{t.title}</p>
                      <p className="text-xs text-foreground-600 mt-0.5 leading-relaxed">{t.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-lg border border-background-200/80 bg-foreground-950 text-background-100 p-5 relative overflow-hidden flex-1">
              <i className="ri-heart-3-fill absolute -right-4 -bottom-4 text-7xl text-accent-500/20" />
              <p className="text-sm leading-relaxed text-background-100/85 max-w-xs">
                看到不舒服的内容？别急着下场开骂。
                <span className="text-accent-400 font-medium">点右上角举报</span>
                ，编辑 5 分钟内处理。理性围观，才是吃瓜的正确打开方式。
              </p>
            </div>
          </div>

          {/* 右：FAQ 手风琴 */}
          <div className="lg:col-span-7">
            <div className="rounded-lg border border-background-200/80 bg-background-50 divide-y divide-background-200/80 overflow-hidden">
              {FAQ.map((f, i) => {
                const open = openId === i;
                return (
                  <div key={i}>
                    <button
                      onClick={() => setOpenId(open ? -1 : i)}
                      className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left"
                    >
                      <span className="inline-flex items-center gap-3">
                        <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-accent-100 text-accent-800 text-xs font-bold">
                          Q{i + 1}
                        </span>
                        <span className={"text-[15px] font-semibold " + (open ? "text-primary-700" : "text-foreground-900")}>
                          {f.q}
                        </span>
                      </span>
                      <i className={open ? "ri-subtract-line text-primary-600" : "ri-add-line text-foreground-400"} />
                    </button>
                    {open && (
                      <div className="px-5 pb-5 pl-14 pr-8 animate-cg-rise">
                        <p className="text-sm text-foreground-700 leading-relaxed border-l-2 border-accent-400 pl-3">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}